import { z } from 'zod'
import { permissionSchema } from './enums.js'
import { roleRefSchema } from './role.js'
import { lenientUuidSchema, timestampSchema } from './common.js'

export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  // OIDC/Keycloak-provided avatar URL (nullable — not every IdP sends one).
  avatarUrl: z.string().nullable(),
  // Embedded role reference: `id` for FK lookups, `name`/`description` for
  // display, `system` for UI affordances (disable delete on seeded rows).
  // The full permission set lives on the role row; resolve via the
  // server-derived `permissions` on currentUser rather than joining the role
  // on every user payload.
  role: roleRefSchema,
  createdAt: timestampSchema,
})
export type User = z.infer<typeof userSchema>

// Sync-time payload returned by `syncCurrentUser`. Carries the user row plus
// the effective permission set resolved from their role on the server — the
// client never derives this from `role.id`, so an admin can revoke
// permissions without the SPA caching stale grants.
export const currentUserSchema = userSchema.extend({
  permissions: z.array(permissionSchema),
})
export type CurrentUser = z.infer<typeof currentUserSchema>

export const updateUserRoleInputSchema = z.object({
  roleId: lenientUuidSchema,
})
export type UpdateUserRoleInput = z.infer<typeof updateUserRoleInputSchema>
